export interface SeasonLike {
  id: number | string;
  starts_on?: string | null;
}

export interface EtsLike {
  id: number | string;
  season: SeasonLike;
}

const dateOf = (d?: string | null): string | null =>
  d ? d.slice(0, 10) : null;

// The most recent season whose starts_on is on or before `isoDate`.
export function seasonForDate<T extends SeasonLike>(
  seasons: T[] | undefined,
  isoDate: string | null | undefined
): T | null {
  if (!seasons || !isoDate) return null;
  const ref = isoDate.slice(0, 10);
  const eligible = seasons.filter(
    (s) => s.starts_on != null && dateOf(s.starts_on)! <= ref
  );
  if (eligible.length === 0) return null;
  return eligible.reduce((best, s) =>
    dateOf(s.starts_on)! > dateOf(best.starts_on)! ? s : best
  );
}

// Among a team's external_team_seasons, the most recent whose season starts on
// or before the reference season (exact match wins; never the future).
export function mostRecentEtsUpTo<T extends EtsLike>(
  etss: T[] | undefined,
  referenceSeason: SeasonLike | null | undefined
): T | undefined {
  if (!etss || !referenceSeason?.starts_on) return undefined;
  const ref = dateOf(referenceSeason.starts_on)!;
  const eligible = etss.filter(
    (e) => e.season?.starts_on != null && dateOf(e.season.starts_on)! <= ref
  );
  if (eligible.length === 0) return undefined;
  return eligible.reduce((best, e) =>
    dateOf(e.season.starts_on)! > dateOf(best.season.starts_on)! ? e : best
  );
}
